import css from 'styled-jsx/css';

export default css`@charset "UTF-8";
.btnMain {
  background-color: #f0f2f9;
  border-radius: 100px; }

.icon.restaurant:before,
.icon[type='restaurant']:before,
.icon[type='餐廳']:before {
  background-image: url(https://static.popdaily.com.tw/img/globalicon/icon-deepgrey/restaurant.png?0425); }

.icon:before {
  content: '';
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 1.5em;
  height: 1.5em; }

.icon--address:before {
  background-image: url(https://static.popdaily.com.tw/img/globalicon/purple/tag.png?0425); }

.icon--clock:before {
  background-image: url(https://static.popdaily.com.tw/img/globalicon/purple/clock.png?0425); }

.icon--phone:before {
  background-image: url(https://static.popdaily.com.tw/img/globalicon/purple/phone.png?0425); }

.icon--sparkle:before {
  background-image: url(https://static.popdaily.com.tw/img/globalicon/purple/sparkle.png?0425); }

.icon--smileFace:before {
  background-image: url(https://static.popdaily.com.tw/img/globalicon/purple/smile-face.png?0425); }

.icon--copy:before {
  background-image: url("/statics/images/copy.svg"); }

.icon--more:before {
  background-image: url(https://static.popdaily.com.tw/img/globalicon/grey-right.png?0425); }

.icon--emptyStar:before {
  background-image: url(https://www.popdaily.com.tw/img/icon/inactive_2@3x.png); }

.icon--fb:before {
  background-image: url(https://www.popdaily.com.tw/img/globalicon/icon-footerNav-facebook@3x.png); }

.icon--messenger:before {
  background-image: url(https://www.popdaily.com.tw/img/globalicon/icon-footerNav-messemger@3x.png); }

.icon--line:before {
  background-image: url(https://www.popdaily.com.tw/img/globalicon/icon-footerNav-line@3x.png); }

.icon--copyLink:before {
  background-image: url(https://www.popdaily.com.tw/img/globalicon/share-link@3x.png); }

.icon--flag:before {
  background-image: url(https://www.popdaily.com.tw/img/globalicon/share-alert@3x.png); }

.icon--report:before {
  background-image: url(https://www.popdaily.com.tw/img/globalicon/share-report@3x.png); }

.icon--arrowBottom {
  background-image: url(../statics/images/chevron-down.png); }

.container {
  margin: auto;
  padding-left: 0;
  padding-right: 0; }
  @media (min-width: 576px) {
    .container {
      max-width: 576px; } }
  @media (min-width: 768px) {
    .container {
      max-width: 768px; } }
  @media (min-width: 992px) {
    .container {
      max-width: 992px; } }
  @media (min-width: 1216px) {
    .container {
      max-width: 1216px; } }

.padding {
  padding-right: 12px;
  padding-left: 12px; }
  @media (min-width: 576px) {
    .padding {
      padding-right: 16px;
      padding-left: 16px; } }
  @media (min-width: 768px) {
    .padding {
      padding-right: 32px;
      padding-left: 32px; } }
  @media (min-width: 992px) {
    .padding {
      padding-right: 32px;
      padding-left: 32px; } }
  @media (min-width: 1216px) {
    .padding {
      padding-right: 32px;
      padding-left: 32px; } }

.padding--xs {
  padding-right: 12px;
  padding-left: 12px; }
  @media (min-width: 576px) {
    .padding--xs {
      padding-right: 16px;
      padding-left: 16px; } }
  @media (min-width: 768px) {
    .padding--xs {
      padding-right: 32px;
      padding-left: 32px; } }
  @media (min-width: 992px) {
    .padding--xs {
      padding-right: 32px;
      padding-left: 32px; } }
  @media (min-width: 1216px) {
    .padding--xs {
      padding-right: 32px;
      padding-left: 32px; } }

@media (min-width: 576px) {
  .padding--sm {
    padding-right: 16px;
    padding-left: 16px; } }

@media (min-width: 768px) {
  .padding--sm {
    padding-right: 32px;
    padding-left: 32px; } }

@media (min-width: 992px) {
  .padding--sm {
    padding-right: 32px;
    padding-left: 32px; } }

@media (min-width: 1216px) {
  .padding--sm {
    padding-right: 32px;
    padding-left: 32px; } }

@media (min-width: 768px) {
  .padding--md {
    padding-right: 32px;
    padding-left: 32px; } }

@media (min-width: 992px) {
  .padding--md {
    padding-right: 32px;
    padding-left: 32px; } }

@media (min-width: 1216px) {
  .padding--md {
    padding-right: 32px;
    padding-left: 32px; } }

@media (min-width: 992px) {
  .padding--lg {
    padding-right: 32px;
    padding-left: 32px; } }

@media (min-width: 1216px) {
  .padding--lg {
    padding-right: 32px;
    padding-left: 32px; } }

@media (min-width: 1216px) {
  .padding--xl {
    padding-right: 32px;
    padding-left: 32px; } }

.clap-container {
  font-weight: bold;
  display: flex; }

.clap {
  background-image: url(../statics/images/icon/small-clap@3x.png);
  background-size: 16px 16px;
  margin-left: 4px;
  width: 16px; }

.clapNum {
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 0.4px;
  color: #7d7af4;
  margin-left: 2px; }
`